import React from 'react';
import flouride from '../../../images/flouride.png';
import cavity from '../../../images/cavity.png';
import teath from '../../../images/teath.png';
import ServiceDetail from '../../../components/Home/ServiceDetail/ServiceDetail';
import './Services.css';

const serviceData = [
    {
        name: 'Fluoride Treatment',
        img: flouride,
        desc: 'Our dental clinic offers expert fluoride treatment to bolster your dental health and preserve your radiant smile.'
    },
    {
        name: 'Cavity Filling',
        img: cavity,
        desc: 'Our skilled dentists use advanced techniques and high-quality materials to gently clean the cavity and restore the affected tooth with precision.'
    },
    {
        name: 'Teeth Whitening',
        img: teath,
        desc: 'Using state-of-the-art techniques and safe, effective whitening agents, we can lighten the shade of your teeth, giving you a dazzling smile that exudes confidence.'
    }
]

const Services = () => {
    return (
        <section className="services-container mt-5" id="serviceContaint">
            <div className="text-center">
                <h5 className="brand-color"
                    style={{
                        fontWeight: "bold"
                    }}
                >OUR SERVICES</h5>
                <h2
                    style={{
                        fontWeight: "bold"
                    }}
                >Services We Provide</h2>
            </div>
            <div className="d-flex justify-content-center mt-5">
                <div className="w-75 row">
                    {
                        serviceData.map(service => <ServiceDetail service={service} key={service.name}></ServiceDetail>)
                    }
                </div>
            </div>
        </section>
    );
};

export default Services;